<!-- <div *ngIf="isTrainingMode" class="bg-green-600 text-white font-semibold text-center">
  TRAINING MODE ACTIVE
</div> -->
<mat-toolbar color="primary" class="mat-elevation-z7 app-header" style="z-index:2;" [class.visible]="isFullScreen">
  <button mat-icon-button (click)="toggleSideNav(0)">
    <mat-icon>menu</mat-icon>
  </button>
  <a [routerLink]="['/home/dashboard']" routerLinkActive="is-active">
    <picture class="h-12">
      <source srcset="../../assets/logo_sm.jpg" media="(min-width: 300px) and (max-width: 576px)">
      <source srcset="../../assets/logo.jpg" media="(min-width: 576px)">
      <img srcset="../../assets/logo.jpg" alt="Labrador AI" height="50px" class="h-12">
    </picture>
  </a>
  <span class="app-spacer"></span>
  <div [formGroup]="toolbarForm">
    <!-- [value] is dropped: the reactive form control owns the rendered value, so the
         binding was inert and only masked that the control had not been seeded.
         Selection moved from (click) on the option to (optionSelected) on the
         autocomplete so keyboard picks (autoActiveFirstOption + Enter) work too. -->
    <input class="search" type="text" placeholder="Select Store" matInput [formControl]="filter"
      [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="storeName"
      (optionSelected)="storeSelected($event.option.value)">
      <mat-option *ngFor="let store of stores" [value]="store">
        {{store.store_name}}
      </mat-option>
    </mat-autocomplete>
  </div>
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logout()">
      <mat-icon>power_settings_new</mat-icon>
      <span>Logout</span>
    </button>
    <button mat-menu-item (click)="openFullscreen()" *ngIf="!isFullScreen">
      <mat-icon>fullscreen</mat-icon>
      <span>Fullscreen</span>
    </button>
    <button mat-menu-item (click)="closeFullscreen()" *ngIf="isFullScreen">
      <mat-icon>fullscreen_exit</mat-icon>
      <span>Exit Fullscreen</span>
    </button>
  </mat-menu>
</mat-toolbar>

<mat-sidenav-container class="app-container xs:pt-[60px]" [class.visible]="isFullScreen"
  [ngClass]="{ 'mt-7': isTrainingMode }">
  <mat-sidenav #snav mode="side" [class.snav-opened]="opened" [class.snav-closed]="!opened" opened disableClose>
    <div class="sidenav" [class.store-select-dot]="opened">
      <div class="flex flex-row justify-between items-center my-3">
        <button mat-icon-button (click)="toggleSideNav(0)" class="ml-2">
          <mat-icon>menu</mat-icon>
        </button>

        <div class="text-left w-full" *ngIf="opened">
          <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900">{{selectedStoreName}}</p>
          <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">{{store?.address}}</p>
        </div>

        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>Logout</span>
          </button>
          <button mat-menu-item (click)="openFullscreen()" *ngIf="!isFullScreen">
            <mat-icon>fullscreen</mat-icon>
            <span>Fullscreen</span>
          </button>
          <button mat-menu-item (click)="closeFullscreen()" *ngIf="isFullScreen">
            <mat-icon>fullscreen_exit</mat-icon>
            <span>Exit Fullscreen</span>
          </button>
        </mat-menu>
      </div>
      <div *ngIf="opened">
        <div [formGroup]="toolbarForm" class="flex flex-row items-center w-full justify-center">
          <mat-form-field class="w-full" appearance="fill" subscriptSizing="dynamic">
            <mat-label>Select Store</mat-label>
            <!-- [value]="selectedStoreName" removed on both sides of this merge: the
                 [formControl] owns the rendered value, so the binding was ignored and the
                 field read as empty even with a store selected. home-layout.component.ts
                 seeds the control itself in setStoreFilterDisplay(). The mat-label above
                 already reads "Select Store", so the duplicate placeholder is dropped;
                 width comes from .search in the scss, not an inline override. -->
            <!--
            Superseded (kept per convention):
            <input class="search" type="text" placeholder="Select Store" matInput [formControl]="filter"
              [matAutocomplete]="auto" style="width: 163px;">
            -->
            <input class="search" type="text" matInput [formControl]="filter"
              [matAutocomplete]="auto">
          </mat-form-field>
          <!-- class= lands on the dropdown panel (overlay layer); _dark-theme.scss keeps it light
               like the rest of the sidenav while the Orders page is in dark mode. -->
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="storeName"
            class="sidenav-store-panel"
            (optionSelected)="storeSelected($event.option.value)">
            <mat-option *ngFor="let store of stores" [value]="store">
              {{store.store_name}}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>

    </div>
    <div class="sidenav">
      <div class="flex flex-row overflow-x-hidden">
        <app-side-nav [opened]="opened" (click)="isSmallScreen() ? toggleSideNav(0) : dummy() "></app-side-nav>
      </div>

    </div>
  </mat-sidenav>

  <mat-sidenav-content [ngStyle]="{'margin-left.px': contentMargin}">
    <div class="basic-container smooth-scroll sm-33">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>


<!--
  New-online-order alert. `isOrdersView` is raised by the /order/{storeId}/sub push when
  view_notified == false && is_pos == false (see initMqtt()), i.e. an order nobody has
  accepted yet. The blinking Orders tab is driven by the same flag in orders.component.ts.

  ENG-5242: the sound is additionally gated on `disable_new_order_sound`. Manual-accept
  stores (auto_accept_orders = false) legitimately want the VIEW queue without the looping
  audio; before this flag the two were welded to the one `view_notified` boolean. Only the
  <audio> is suppressed -- `isOrdersView` still blinks the tab, so a muted store keeps a
  visual cue and orders don't sit unnoticed.
-->
<span *ngIf="isOrdersView && !isNewOrderSoundDisabled">
  <audio autoplay loop>
    <source src="assets/audio/Xbox 360 Power.mp3" type="audio/ogg">
  </audio>
</span>